import { getState } from "../state/store";
import { selectLocations } from "../state/selectors";

import { objectUtil } from "../utils";

const getLocationNameById = (locationId) => {
  const locations = selectLocations()(getState());

  const locationsList = locations ? [].concat(...Object.values(locations)) : [];

  if (locationId && !objectUtil.isEmpty(locationsList)) {
    return locationsList.find((location) => location.id === locationId)?.name;
  }

  return null;
};

const formatLocations = (locations = []) => {
  const markets = Object.keys(locations);
  const locationsList = [];

  markets.forEach((market) => {
    const marketLocations = locations[market];

    locationsList.push(
      ...marketLocations.map((location) => {
        return { ...location, market, locationName: `${location?.name}, ${location?.city}` };
      })
    );
  });

  return locationsList;
};

const locationUtil = {
  getLocationNameById,
  formatLocations
};

export default locationUtil;
